function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: 0.424,
  y: 20.333,
  width: 25.256,
  height: 2.486,
  rx: 1.243,
  transform: "rotate(-45 .424 13.333)",
  fill: "#DAF0ED",
  stroke: "#828A90",
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 3.5,
  r: 2.2,
  fill: "#DAF0ED",
  stroke: "#828A90",
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 18.5,
  r: 2.2,
  fill: "#DAF0ED",
  stroke: "#828A90",
  strokeWidth: 0.6
}));

export default SvgComponent;